export function useFast(): globalThis.ComputedRef<boolean> {
  const config = useRuntimeConfig()
  return computed(() => config.public.fast?.toString() === 'true' || import.meta.dev)
}
